import MobileHeader from "../../../../layout/mobile-header";
import MobileTournamentMoreInfo from "./competitions/info";
import MobileTournamentMoreITM from "./competitions/itm";
import MobileTournamentMoreStructure from "./competitions/structure";
import { MobileTournamentMoreWrapper } from "./style";
import { TournamentResponse } from "../../../../api/tournament";

export interface MobileTournamentInfoProps {
  onClose: () => void;
  tournament: TournamentResponse | null;
}

const MobileTournamentMore = ({
  onClose,
  tournament,
}: MobileTournamentInfoProps) => {
  return (
    <MobileTournamentMoreWrapper>
      <MobileHeader title="토너먼트 자세히보기" back={onClose} />
      <MobileTournamentMoreInfo tournament={tournament} />
      <MobileTournamentMoreITM tournament={tournament} />
      <MobileTournamentMoreStructure tournament={tournament} />
    </MobileTournamentMoreWrapper>
  );
};

export default MobileTournamentMore;
